import {gql} from "@irati/utils/gql"

export const fullUserList = gql`
  fragment fullUserList on UserList {
    limit
    count
    offset
    results {
      ...fullUser
    }
  }
`

const fragment = gql`
  fragment fullUser on User {
    uuid
    dateOfBirth {
      day
      month
      year
    }
    businessId
    billingUnitId
    email
    externalUserId
    externalStartDate
    deactivationDate
    externalEmployeeId
    firstName
    gender
    isEnabled
    isActivated
    lastName
    language
    metadata {
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
    marketingEmailsAllowed
    phoneNumber
    profileImageUrl
    source
    teamIds
    isManagedExternally
    isGlobalAdmin
    isManager
    regionId
    role
    primaryTeamId
    userType
    invitedBy {
      uuid
      firstName
      lastName
    }
    invitedUsers {
      userId
      status
    }
    teamAssignments {
      teamId
      assignment
      isBudgetHolder
    }
    managedFields {
      managers
      fields {
        manager
        field
      }
    }
    employmentDetails {
      job_grade
      probation_end_date
      termination_date
      hours_per_week
      annual_gross_salary
      ni_number
      pay_frequency
      employee_number
      roles
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
